import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Firestore, collection, getDocs, doc, getDoc } from '@angular/fire/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Observable, from } from 'rxjs';
import CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private firestore: Firestore
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return from(this.checkAccess(state.url));
  }

  private checkAccess(returnUrl: string): Promise<boolean> {
    const auth = getAuth();

    return new Promise((resolve) => {
      onAuthStateChanged(auth, async (user) => {
        if (!user) {
          this.router.navigate(['/auth/login'], { queryParams: { returnUrl } });
          resolve(false);
          return;
        }

        const currentUid = user.uid;
        const currentEmail = user.email;
        const md5CurrentEmail = CryptoJS.MD5(currentEmail.trim().toLowerCase()).toString();

        const eventAdminsSnapshot = await getDocs(collection(this.firestore, 'events_management'));

        for (const eventAdminDoc of eventAdminsSnapshot.docs) {
          const eventId = eventAdminDoc.id;
          const adminDocRef = doc(this.firestore, `events_management/${eventId}/participants/${md5CurrentEmail}`);
          const adminDocSnap = await getDoc(adminDocRef);
          if (adminDocSnap.exists() && adminDocSnap.data().IsSuperAdmin === true) {
            resolve(true);
            return;
          }
        }

        this.router.navigate(['/auth/login'], { queryParams: { returnUrl } });
        resolve(false);
      });
    });
  }
}
